/*global $:false, screen:false, Modernizr:false, __:false, routeMatcher:false, location:false, _ */

;(function () {
    "use strict";

    var params = {
        version: 7,
        root: '.layout',
        showLoadingAfter: 0,
        closeByEscape: true,
        loadDataUrl: '/overlay.json',
        route: routeMatcher('#overlay-:type-:list-:id'),
        routeGroup: routeMatcher('#overlay-:type-:list-:group-:id'),
        routeForum: routeMatcher('#overlay-:type-:list-post:post-num:num-:id'),
        delegateTo: '.js-overlay-media',
        selector: 'a[data-type="photo"], button[data-type="photo"]'
    };

    var overlayClass = 'photooverlay';
    var windowClass  = 'photooverlay__window';
    var closeButton  = '<div class="photooverlay__close"><span class="photooverlay__logo b-icon-nevesta_smaller"></span><i class="photooverlay__close__icon icon-cross"></i></div>';
    var closeClass   = 'photooverlay__close__icon';
    var arrowClass   = 'photooverlay__photopane__arrow';
    var unauthClass  = 'b-media-overlay-comment__input_disabled';

    var list;
    var listingScrollTop = 0;

    var debug = { // debug off: null object
        log:            $.noop,
        info:           $.noop,
        warn:           $.noop,
        error:          $.noop,
        dir:            $.noop,
        dirxml:         $.noop,
        group:          $.noop,
        groupEnd:       $.noop,
        groupCollapsed: $.noop,
        time:           $.noop,
        timeEnd:        $.noop,
        profile:        $.noop,
        profileEnd:     $.noop,
        assert:         $.noop
    };

    debug = window.console;

    $(function() {
        if ($('#sfWebDebug').length) {
            debug = window.console;
            params.loadDataUrl = location.pathname.match(/^\/[^\/]*/)[0] + params.loadDataUrl;
        }
    });

    var replaceState = Modernizr.history ? $.proxy(history, 'replaceState') : $.noop;
    var pushState    = Modernizr.history ? $.proxy(history, 'pushState')    : $.noop;

    var HotKeys = function() {
        var map = {};
        var lastkey;
        function handler(e) {
            if (lastkey === e.keyCode) {
                return;
            }
            if (e.metaKey) {
                return;
            }
            if (e.altKey) {
                return;
            }
            if ('undefined' === typeof map[e.keyCode]) {
                return;
            }
            if (0 < $(e.target.tagName).filter(':text,textarea').length) {
                return;
            }

            lastkey = e.keyCode;
            map[e.keyCode].call();
        }
        function free() {
            lastkey = null;
        }
        this.setKeyHandler = function(keyCode, cb) {
            map[keyCode] = cb;
        };
        this.enable = function() {
            $(document)
                .on('keydown', handler)
                .on('keyup', free);
        };
        this.disable = function() {
            $(document)
                .off('keydown', handler)
                .off('keydown', free);
            lastkey = null;
        };
    };
    $.extend(HotKeys.prototype, {
        ESCAPE: 27,
        LEFT:   37,
        RIGHT:  39,
        SPACE:  39
    });
    var hotKeys = new HotKeys();

    var events = {
        openWindow:      $.Callbacks(),
        closeWindow:     $.Callbacks(),
        loadData:        $.Callbacks(),
        cleanItemHtml:   $.Callbacks(),
        afterRenderItem: $.Callbacks(),
        loadPhoto:       $.Callbacks(),
        previous:        $.Callbacks(),
        next:            $.Callbacks(),
        postComment:     $.Callbacks(),
        ajax:            $.Callbacks()
    };

    var overlayMedia = {
        route: {
            stringify: function(data) {
                if (data.post && data.num) {
                    return params.routeForum.stringify(data);
                }
                return params.route.stringify(data);
            },
            parse: function(url) {
                return params.routeForum.parse(url) || params.routeGroup.parse(url) || params.route.parse(url);
            }
        },
        isOpen: false,
        tpl: null,
        ideabooks: [],
        preloadNeighborDirection: 'next',
        closeUrlHash: '#',
        itemUrlHash: null,
        scrollTop: 0,
        $overlay: [],
        watched_photos_for_promotion: 0,

        hashChange: function() {

            if (overlayMedia.itemUrlHash === location.hash) {
                return;
            }
            var match = overlayMedia.route.parse(location.hash);
            if (match && 'photo' === match.type) {
                debug.info('Overlay URL:', match);

                var listSelector = '.js-overlay-media[data-list="'+match.list+'"]';
                var itemSelector = 'a[data-type="'+match.type+'"][data-id="'+match.id+'"], button[data-type="'+match.type+'"][data-id="'+match.id+'"]';

                if (match.post && match.num) {
                    itemSelector += '[data-post="'+match.post+'"][data-num="'+match.num+'"]';
                }
                var selector = listSelector+' '+itemSelector;
                var $link = $(selector).first();

                if (0 < $link.length) {
                    debug.info('Node found');
                    $link.click();
                }

                else {
                    debug.info('Node not found: '+selector);
                    var $list = $(listSelector);
                    if (!$list.length) {
                        $list = $('<div/>').data('list', match.list);
                    }
                    var media = new Item($.extend(match, { list: $list }));
                    overlayMedia.init();
                    overlayMedia.open(media);
                }
            } else if (overlayMedia.isOpen) {
                overlayMedia.close(null);
            }
        },

        setBAuthorPosition: function () {

            var $author = $('.photooverlay__author'),
                topPos, leftPos;

            if ($(window).width() <= 1024) {
                topPos  = 0;
                leftPos = 0;
            }
            else {
                var $image = $('.photooverlay__photopane__image');
                topPos  = parseInt($image.css('margin-top'))  + 8,
                leftPos = parseInt($image.css('margin-left')) + 8;
            }

            $author.css({
                'top':  topPos,
                'left': leftPos,
                'display': 'block'
            });
        },

        setFixedElemets: function () {

            if (!Modernizr.touch) {

                var $overlay      = $('.photooverlay');
                var $comments     = $overlay.find('.photooverlay__comments');
                var $sidebar      = $overlay.find('.photooverlay__sidebar');
                var $inner        = $sidebar.find('.photooverlay__sidebar__inner');
                var $scrollBottom = $('<div class="photooverlay__scroll-bottom"></div>');
                var getLeft       = function ($element) {
                    return $overlay.find('.photooverlay__window').outerWidth() - $(window).scrollLeft() - $element.outerWidth();
                };

                $scrollBottom.appendTo($overlay);
                $scrollBottom.css('left', getLeft($scrollBottom));

                var _template = _.trim(
                    '<button class="photooverlay__scroll-bottom__button"                    ' +
                    '        data-tracking-event-category="Photo overlay"                            ' +
                    '        data-tracking-event-action="Click on see comments"                             ' +
                    '>                                                                      ' +
                    '    <% if (media.comments.length > 0) { %>                             ' +
                    '        Читать комментарии                                             ' +
                    '        (<%= media.comments.length %>)                                 ' +
                    '    <% } else { %>                                                     ' +
                    '        Комментировать                                                 ' +
                    '    <% } %>                                                            ' +
                    '    <i class="photooverlay__scroll-bottom__icon icon-down-circle"></i> ' +
                    '</button>'
                ).replace(/ +/g, ' ');

                $overlay.on('ScrollToComment::rerender', function() {
                    $scrollBottom.html(
                        _.template(_template, { media: overlayMedia.item.data })
                    );
                });

                var isNeedToHide = function () {
                    return ($comments.offset().top <= (($(window).height() / 2) || 200)) ||
                           (($overlay.scrollTop() + $(window).height() + 200) > $overlay.outerHeight(true) + $comments.outerHeight(true));
                };

                var updateButton = _.debounce(function () {
                    if (($inner.height() + parseInt($sidebar.css('padding-top')) + parseInt($sidebar.css('padding-bottom'))) >= $(document).height() + ($scrollBottom.height() * 0.5)) {
                        $scrollBottom.hide();
                    }
                    else {
                        $scrollBottom.show();
                    }

                    if (isNeedToHide()) {
                        $scrollBottom.addClass('photooverlay__scroll-bottom_hidden');
                    }
                    else {
                        $scrollBottom.removeClass('photooverlay__scroll-bottom_hidden');
                    }
                    $scrollBottom.blur();
                }, 250);

                updateButton();

                $(window).on('resize.photooverlayOveflowiseLayout scroll', function () {
                    updateButton();
                    _.defer(function() {
                        $scrollBottom.css('left', getLeft($scrollBottom));
                    });
                });

                $overlay.off('.scroll.scrollToComment');
                $overlay.on('scroll.scrollToComments', updateButton);
                $scrollBottom.off('.click.scrollToComment');
                $scrollBottom.on('click.scrollToComments falseClick.scrollToComments', function () {
                    $comments = $overlay.find('.photooverlay__comments');
                    $overlay.animate({ scrollTop: $comments.offset().top + $overlay.scrollTop() }, updateButton);
                });
            }
        },

        init: function() {
            debug.time('init');
            overlayMedia.init = $.noop;

            // overlay
            this.$overlay = $('<div/>')
                .addClass(overlayClass)
                .addClass(overlayClass + '_initing')
                .addClass(window.UseWhitePhotoverlay ? 'photooverlay_white' : '')
                .addClass(overlayClass + '_loading')
                .addClass(overlayClass + '_' + ((window.MediaQueryState.phones && $('body').hasClass('layout_mobilised')) ? 'mobile' : 'desktop'))
                .click(function(e) {
                    if (e.target === this) {
                        overlayMedia.close();
                        return false;
                    }
                }
            );

            overlayMedia.$overlay = this.$overlay;

            // window
            this.$win = $('<div/>')
                .addClass(windowClass)
                .appendTo(this.$overlay);

            // closeButton
            $(closeButton).appendTo(this.$win);
            this.$win.on('click', '.' + closeClass, $.proxy(this.close, this));

            this.$node = $('<div/>').addClass('photooverlay__node').appendTo(this.$win);

            // arrows handlers
            this.$node.on('click', '.' + arrowClass + '_prev', this.prevItem);
            this.$node.on('click', '.' + arrowClass + '_next', this.nextItem);

            this.$node.on('mouseenter', '.' + arrowClass, function() {
                window.status = $(this).data('status');
            });
            this.$node.on('mouseleave', '.' + arrowClass, function() {
                window.status = '';
            });

            // неавторизованный
            this.$node.on('click focus', '.' + unauthClass, function() {
                $(this).blur();
                var item = overlayMedia.item;
                $('.b-enter').trigger('openScreen', [ 'auth' ]);
                $.ajax({
                    url:      $(this).data('url'),
                    data:     {
                        type:    item.data.type,
                        id:      item.data.id,
                        referer: location.toString()
                    },
                    dataType: 'json',
                    type:     'POST',
                    success: function(result) {
                        debug.log('unauth login store action success', result);
                    },
                    error: function() {
                        debug.warn('unauth login store action error', arguments);
                    }
                });
            });

            // add comment
            this.$node.on('submit', '.photooverlay__new-comment', function(event) {
                event.preventDefault();
                $('.alert-error', this).remove();
                var formData = $(this).serialize();
                var controls = $('textarea,button', this).prop('disabled', true);
                var item = overlayMedia.item;
                $.ajax({
                    url:      this.action,
                    data:     formData,
                    method:   'post',
                    dataType: 'json',
                    error: function() {
                        controls.prop('disabled', false);
                    },
                    success: function(comment) {
                        if ('undefined' === typeof comment.error) {
                            item.data.comment_count ++;
                            item.data.comments.push(comment);
                            overlayMedia.showItem(item);
                            item.clearCache();
                            events.postComment.fire();
                        }
                        else {
                            controls.prop('disabled', false);
                            $('<div/>')
                                .text(comment.error)
                                .append('<button type="button" class="close" data-dismiss="alert">&times;</button>')
                                .addClass('alert alert-error')
                                .insertBefore(controls.first())
                                .on('click', '.close', function(event) {
                                    $(event.delegateTarget).remove();
                                });
                        }
                    }
                });

                return false;
            });

            events.afterRenderItem.add(function(item, $node) {

                if (item.data.ideabook_pin_after_login) {
                    item.data.ideabook_pin_after_login = false;
                    item.clearCache();
                    $node.find('.i-ideabook-pin-button').click();
                }

                overlayMedia.setFixedElemets();
            });

            // other photos in gallery
            this.$node.on('click', '.b-media-overlay-album-items-item__link', function(e) {
                var isNotPrimaryMouseButton = 'undefined' !== typeof e.which && 1 !== e.which;
                if (isNotPrimaryMouseButton) {
                    return;
                }

                e.preventDefault();

                var media = new Item({
                    type: overlayMedia.item.data.type,
                    id:   $(this).data('id'),
                    list: $('<div/>').data('list', 'user')
                });

                overlayMedia.open(media);
                events.clickThumbnail.fire();
            });

            // scrollbars
            this.documentScrollbars = {
                scrollbarSize: 0,
                $spaceNode: $(params.root),
                $scrollbarsNode: $(),
                hide: function() {
                    var self = this;
                    var $html = $('html:first');

                    if (window.MediaQueryState.phones && !$('body').hasClass('layout_mobilised')) {
                        var $body = $('body:first');

                        if (!_.isUndefined(screen.height)) {
                            overlayMedia.$overlay.css('height', screen.height + 'px');
                        }

                        self.$spaceNode.css('display', 'none');
                        $html.css('background', '#FFFFFF');
                        $body.css('background', '#FFFFFF');
                        return;
                    }

                    var widthBefore = $html.width();

                    this.scrollTop = $(window).scrollTop();

                    var overflowise = function () {

                        self.$spaceNode.css({
                            'height': $(window).height() + self.scrollTop,
                            'margin-top': self.scrollTop * -1,
                            'overflow': 'hidden',
                            'min-width': 0
                        });
                    };

                    overflowise();
                    $(window).on('resize.photooverlayOveflowiseLayout', function () {
                        overflowise();
                    });

                    if (0 === this.scrollbarSize) {
                        this.scrollbarSize = $html.width() - widthBefore;
                        this.$spaceNode.css('padding-right', '+=' + this.scrollbarSize);
                    }
                },
                show: function() {
                    var self = this;

                    if (window.MediaQueryState.phones && !$('body').hasClass('layout_mobilised')) {
                        var $html = $('html:first');
                        var $body = $('body:first');

                        if (!_.isUndefined(screen.height) && !_.isUndefined(screen.width)) {
                            overlayMedia.$overlay.css('height', '');
                        }

                        self.$spaceNode.css('display', '');
                        $html.css('background', '');
                        $body.css('background', '');
                        return;
                    }

                    self.scrollbarSize = 0;

                    self.$spaceNode.css({
                        'height': '',
                        'margin-top': '',
                        'overflow': '',
                        'padding-right': '',
                        'min-width': ''
                    });

                    $(window).off('resize.photooverlayOveflowiseLayout');

                    $(window).scrollTop(self.scrollTop);
                }
            };

            // loading animation show only after timeout

            this.loading = {
                timer: null,
                show: function(timeout) {
                    this.timer = setTimeout(function() {
                        $('.' + overlayClass).addClass(overlayClass + '_loading');
                    }, timeout);
                },
                hide: function() {
                    $('.' + overlayClass).removeClass(overlayClass + '_loading');
                    clearTimeout(this.timer);
                }
            };

            // ESC
            if (params.closeByEscape) {
                hotKeys.setKeyHandler(hotKeys.ESCAPE, $.proxy(this.close, this));
            }

            // LEFT & RIGHT arrows
            hotKeys.setKeyHandler(hotKeys.LEFT,  this.prevItem);
            hotKeys.setKeyHandler(hotKeys.RIGHT, this.nextItem);

            debug.timeEnd('init');
        },

        open: function(item, action, trackingParams) {
            debug.time('open & load');
            this.item = item;
            this.postOpenAction = action || '';

            this.updateHashTag();

            if (/\?comments$/.test(document.location.hash)) {
                this.postOpenAction = "scroll-to-comments";
            }

            if (item && item.data && item.data.list) {
                list = item.data.list;
            }

            if (!this.isOpen) {
                this.documentScrollbars.hide();
                this.$overlay.hide().prependTo('body').fadeIn('fast');

                hotKeys.enable();
                this.isOpen = true;
                events.openWindow.fire(trackingParams);
            }

            events.loadData.add(this.refreshIfNeed);
            events.loadData.add(this.initTemplate);
            events.afterRenderItem.add(function () {
                $('.photooverlay').trigger('ScrollToComment::rerender');

                if (this.postOpenAction == "scroll-to-comments") {
                    this.postOpenAction = '';
                    var $overlay = $('.photooverlay');
                    var $scrollBottom = $overlay.find('.photooverlay__scroll-bottom');
                    _.defer(function () {
                        $scrollBottom.triggerHandler('falseClick.scrollToComments');
                    });
                }
            }.bind(this));

            this.loading.show(params.showLoadingAfter);
            var targetTpl = window.MediaQueryState.phones && $('body').hasClass('layout_mobilised') ? 'mobile' : 'desktop';
            item.loadData(_.isNull(this.tpl) ? { tpl: targetTpl } : {})
            .always($.proxy(this.loading.hide, this.loading))
            .done($.proxy(this.showItem, this, item))
            .fail(function() {
                overlayMedia.$node.html('<p style="margin: 0 50px">'+__('Фото не найдено')+'</p>');
            });
        },

        // reload page if version is change and is not compatible
        refreshIfNeed: function(data)
        {
            if ('undefined' !== typeof data.refresh && data.refresh) {
                location.reload(true);
            }
        },

        initTemplate: function(data)
        {
            if (null === overlayMedia.tpl && data.tpl) {
                overlayMedia.tpl = data.tpl;
                delete data.tpl;

                overlayMedia.ideabooks = data.ideabooks;
                delete data.ideabooks;

                events.loadData.remove(overlayMedia.initTemplate);
            }
        },

        close: function(e) {
            if (e instanceof $.Event) {
                e.preventDefault();
            }

            if (!this.isOpen) {
                return false;
            }

            events.cleanItemHtml.fire();
            events.closeWindow.fire();

            this.isOpen = false;
            $(window).off('resize.photooverlaySetBAuthorPosition');
            $('.' + overlayClass).addClass(overlayClass + '_initing');
            hotKeys.disable();
            this.loading.hide();
            this.$node.empty();
            this.$overlay.fadeOut('fast', $.proxy(this.documentScrollbars.show, this.documentScrollbars));

            if (location.hash !== this.closeUrlHash) {
                if (pushState === $.noop) {
                    location.hash = this.closeUrlHash;
                }
                else {
                    pushState(null, document.title, location.href.replace(location.hash || /(#.*|)$/, this.closeUrlHash));
                }
            }

            this.itemUrlHash = null;
        },

        showItem: function(item) {
            events.cleanItemHtml.fire();
            this.$node.empty();

            debug.time('render '+item.data.id);

            if ( $(window).outerWidth() <= 360 ) {
                item.data.src = item.data.src.s;
            }
            else if ( $(window).outerWidth() <= 1366 && $(window).outerWidth() > 360 ) {
                item.data.src = item.data.src.m;
            }
            else if ( $(window).outerWidth() <= 1920 && $(window).outerWidth() > 1366 ) {
                item.data.src = item.data.src.l;
            }
            else {
                item.data.src = item.data.src.x;
            }

            var html = window.ejs.render(this.tpl, {
                media: item.data,
                ideabooks: overlayMedia.ideabooks
            });

            debug.timeEnd('render '+item.data.id);

            debug.time('draw');
            this.$node.html(html);
            debug.timeEnd('draw');
            html = null;

            events.afterRenderItem.fire(this.item, this.$node);

            // image loading
            var $img = this.$node.find('.b-media-overlay-content__img');
            this.imageLoader({
                src: item.data.src,
                prepare: function() {
                    $img.addClass('b-media-overlay-content__img_loading');
                },
                ready: function() {
                    $img.removeClass('b-media-overlay-content__img_loading');
                    overlayMedia.setBAuthorPosition();
                    $(window).on('resize.photooverlaySetBAuthorPosition', function() {
                        overlayMedia.setBAuthorPosition();
                    });
                },
                load: function() {
                    debug.timeEnd('open & load');
                    events.loadPhoto.fire();
                    overlayMedia.preloadNeighbor();
                }
            });

            $('.' + overlayClass + '_initing').removeClass(overlayClass + '_initing');

            // prev
            debug.log('Prev: ', this.item.hasPrev());
            if (this.item.hasPrev()) {
                $('.' + arrowClass + '_prev').removeClass(arrowClass + '_disable');
            } else {
                $('.' + arrowClass + '_prev').addClass(arrowClass + '_disable');
            }

            // next
            debug.log('Next: ', this.item.hasNext());
            if (this.item.hasNext()) {
                $('.' + arrowClass + '_next').removeClass(arrowClass + '_disable');
            } else {
                $('.' + arrowClass + '_next').addClass(arrowClass + '_disable');
            }

            this.updateHashTag();

            this.getMarketplacePromotion(item);

            $(document).trigger('Photooverlay::ShowItem', [item]);

            // Initing Social likes
            $('.photooverlay .social-likes').attr('data-url', window.location.origin + '/photo/' + item.data.id + '/');
            $('.photooverlay .social-likes').attr('data-media', item.data.src);
          SocialLikesNext.default(document.querySelector('.photooverlay .social-likes'))
        },

        updateHashTag: function() {
            this.itemUrlHash = this.route.stringify(this.item.data);
            if (location.hash !== this.itemUrlHash) {
                if (!this.isOpen) {
                    this.closeUrlHash = location.hash;
                }
                if ($.noop === pushState) {
                    location.hash = this.itemUrlHash;
                }
                else {
                    pushState(null, document.title, location.href.replace(location.hash || /(#.*|)$/, this.itemUrlHash));
                }
            }
        },

        imageLoader: function(options) {
            debug.time('calculate image size');
            debug.time('load image');
            var $clone = $(new Image()).appendTo($('<div/>').addClass('b-media-overlay-img-ready-detect').prependTo(this.$node)),
                width = $clone.width(),
                height = $clone.height();

            $clone.prop('src', options.src);

            options.prepare();

            var onReadyOnce = $.Callbacks('once').add(options.ready);
            var ready = function() {
                debug.timeEnd('calculate image size');
                window.clearInterval(checkLoadInterval);
                onReadyOnce.fire();
            };
            var checkLoadInterval = window.setInterval(function() {
                if ($clone.prop('complete') || 4 === $clone.prop('readyState') || $clone.width() !== width || $clone.height() !== height) {
                    ready();
                }
            }, 50);

            $clone.on('load', function() {
                debug.timeEnd('laod image');
                ready();
                $clone.parent().remove();
                options.load();
            });
        },

        prevItem: function(e) {
            if (e instanceof $.Event) {
                e.preventDefault();
            }
            if (0 < overlayMedia.item.$prev.length) {
                overlayMedia.item.$prev.click();
            }
            else if ('undefined' !== typeof overlayMedia.item.prevItem) {
                overlayMedia.open(overlayMedia.item.prevItem);
            }
            else if (null !== overlayMedia.item.data.prev) {
                var params = overlayMedia.item.getPrevData();
                var item = overlayMedia.item.getNeighbor(params);
                item.nextItem = overlayMedia.item;
                overlayMedia.item.prevItem = item ;
                overlayMedia.open(item);
            }
            overlayMedia.preloadNeighborDirection = 'prev';
            events.previous.fire();
        },

        nextItem: function(e) {
            if (e instanceof $.Event) {
                e.preventDefault();
            }
            // by dom element of list
            if (0 < overlayMedia.item.$next.length) {
                debug.log('next node');
                overlayMedia.item.$next.click();
            }
            // by Item object
            else if ('undefined' !== typeof overlayMedia.item.nextItem) {
                debug.log('next object');
                overlayMedia.open(overlayMedia.item.nextItem);
            }
            // by id
            else if (null !== overlayMedia.item.data.next) {
                debug.log('next id');
                var params = overlayMedia.item.getNextData();
                var item = overlayMedia.item.getNeighbor(params);
                item.prevItem = overlayMedia.item;
                overlayMedia.item.nextItem = item;
                overlayMedia.open(item);
            }
            overlayMedia.preloadNeighborDirection = 'next';
            events.next.fire();
        },

        isPreloadedNeighbor: function() {
            switch (overlayMedia.preloadNeighborDirection) {
                case 'next':
                    if (overlayMedia.item.nextItem) return true;
                    break;
                case 'prev':
                    if (overlayMedia.item.prevItem) return true;
                    break;
            }
            return false;
        },


        getPreloadNeighborItem: function() {
            var $node, params, item;
            switch (overlayMedia.preloadNeighborDirection) {
                case 'next':
                    $node  = overlayMedia.item.$next     || $();
                    params = overlayMedia.item.getNextData();
                    break;
                case 'prev':
                    $node  = overlayMedia.item.$prev     || $();
                    params = overlayMedia.item.getPrevData();
                    break;
                default:
                    return;
            }

            if (0 !== $node.length) {
                item = getItem($node, overlayMedia.item.$list);
            }
            else if (null !== params) {
                item = overlayMedia.item.getNeighbor(params);
            }
            else {
                return null;
            }

            switch (overlayMedia.preloadNeighborDirection) {
                case 'next':
                    item.data.prev = overlayMedia.item.data.id;
                    break;
                case 'prev':
                    item.data.next = overlayMedia.item.data.id;
                    break;
            }
            return item;
        },

        preloadNeighbor: function() {
            if (overlayMedia.isPreloadedNeighbor()) {
                return;
            }
            var item = overlayMedia.getPreloadNeighborItem();
            debug.log('Preload item:', item);
            if (item) {
                // preload image
                item.loadData().done(function() {
                    var img = new Image();

                    if ( $(window).outerWidth() <= 360 ) {
                        item.data.src = item.data.src.s;
                    }
                    else if ( $(window).outerWidth() <= 1366 && $(window).outerWidth() > 360 ) {
                        item.data.src = item.data.src.m;
                    }
                    else if ( $(window).outerWidth() <= 1920 && $(window).outerWidth() > 1366 ) {
                        item.data.src = item.data.src.l;
                    }
                    else {
                        item.data.src = item.data.src.x;
                    }

                    img.src = item.data.src;
                });
            }
        },

        getMarketplacePromotion: function(item) {
            this.$overlay.removeClass('photooverlay_marketplace-promotion');
            var cookieValue = Cookies.get('nvst_mp_promo_c');
            if (cookieValue == 1) {
                return;
            }

            var params = {
            };
            if (item.$list.data('promotion-category-slug')) {
                params['category_slug'] = item.$list.data('promotion-category-slug');
            }
            if (item.$list.data('promotion-location-id')) {
                params['location_id'] = item.$list.data('promotion-location-id');
            }

            this.watched_photos_for_promotion++;
            if (this.watched_photos_for_promotion % 5 == 1) {
                $(document).trigger(
                    'MarketplacePromotion::GetByPhoto',
                    [
                        this,
                        item.data.id,
                        params,
                        this.showMarketplacePromotion
                    ]
                );
            }
        },

        showMarketplacePromotion: function(self, promotionData) {
            if (!promotionData || typeof promotionData['title'] == 'undefined') {
                return;
            }
            var $block = self.$node.find('.marketplace-promotion-overlay');
            var $image = $block.find('[data-marketplace-promotion-field="image"]');
            var $title = $block.find('[data-marketplace-promotion-field="title"]');
            var $location = $block.find('[data-marketplace-promotion-field="location"]');
            var $link = $block.find('[data-marketplace-promotion-field="link"]');
            var $price = $block.find('[data-marketplace-promotion-field="price"]');
            var $close = $block.find('.marketplace-promotion-overlay__close');

            if (typeof promotionData['image']['src_small'] != 'undefined') {
                $image.attr('src', promotionData['image']['src_small']);
            } else {
                $image.attr('src', '');
            }
            $title.text(promotionData['title']);
            $location.text(promotionData['location_name']);
            $link.attr('href', promotionData['link']);
            if (promotionData['prices']) {
                var minPrice = typeof promotionData['prices']['min'] != 'undefined' ? promotionData['prices']['min'] : 0;
                var maxPrice = typeof promotionData['prices']['max'] != 'undefined' ? promotionData['prices']['max'] : 0;
                var price = '';
                if (minPrice > 0) {
                    var minPriceString = minPrice;
                    if (minPriceString >= 10000) {
                        minPriceString = minPriceString.toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1&nbsp;');
                    }
                    price += minPriceString;
                }
                if (maxPrice > 0) {
                    if (minPrice > 0) {
                        price += '&nbsp;&mdash;&nbsp;';
                    }
                    var maxPriceString = maxPrice;
                    if (maxPriceString >= 10000) {
                        maxPriceString = maxPriceString.toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1&nbsp;');
                    }
                    price += maxPriceString;
                }
                if (minPrice > 0 || maxPrice > 0) {
                    price += '&nbsp;<span class="rouble">руб.</span>'
                }
                $price.html(price);
            }

            $close.on('click', function(e) {
                e.preventDefault();
                Cookies.set('nvst_mp_promo_c', 1, { expires: 1 });
                $block.addClass('marketplace-promotion-overlay_hidden');
                if (typeof window.Tracker != 'undefined') {
                    window.Tracker.pushEvent(
                        {
                            category: 'Marketplace Promotion',
                            action: 'Click on close in overlay',
                            label: $title.text()
                        }
                    );
                }
            });

            $link.off('click');
            $link.on('click', function(e){
                if (typeof window.Tracker != 'undefined') {
                    window.Tracker.ecommerceClickPromo('Marketplace crosspromo', 'Marketplace crosspromo', $title.text(), 'Photo overlay');
                }
            });

            var temp_img = new Image();
            temp_img.src = self.item.data.src;
            var temp_img_width = temp_img.width;
            var temp_img_height = temp_img.height;
            var $photopane = self.$node.find('.photooverlay__photopane__image');
            var photopane_width = $photopane.width();
            var photopane_height = $photopane.height();
            var temp_img_prop = temp_img_width / temp_img_height;
            var photopane_prop = photopane_width / photopane_height;
            var scale = 1;
            if (temp_img_prop < photopane_prop) {
                scale = photopane_height  / temp_img_height;
                var new_img_width = temp_img_width * scale;
                var right_pos = (photopane_width - new_img_width) / 2;
                $block.css('right', right_pos + 'px');
            } else {
                scale = photopane_width  / temp_img_width;
                var new_img_height = temp_img_height * scale;
                var top_pos = (photopane_height - new_img_height) / 2;
                $block.css('top', top_pos + 'px');
            }

            self.$overlay.addClass('photooverlay_marketplace-promotion');
            $block.removeClass('marketplace-promotion-overlay_hidden');
            if (typeof window.Tracker != 'undefined') {
                window.Tracker.ecommerceShowPromo('Marketplace crosspromo', 'Marketplace crosspromo', $title.text(), 'Photo overlay');
            }
        }
    };

    var Cache = {
        data: {},

        get: function(key) {
            if ('undefined' === typeof this.data[key]) {
                this.data[key] = {};
            }
            return this.data[key];
        },

        remove: function(key) {
            if ('undefined' !== typeof this.data[key]) {
                this.data[key] = {};
                delete this.data[key];
            }
        }
    };

    var Item = function (params) {
        this.$prev = params.prev || $();
        this.$next = params.next || $();
        this.$list = params.list || $();
        this.data = $.extend({}, params, {
            prev:  this.$prev.data('id')    || null,
            next:  this.$next.data('id')    || null,
            list:  this.$list.data('list')  || null
        });
        debug.info(this.data.id+' prev: '+this.data.prev+' next: '+this.data.next);
    };

    Item.prototype.getNeighbor = function(params) {
        if ('object' !== typeof params) {
            params = {
                id: params
            };
        }
        var item = new Item($.extend({
            type: this.data.type,
            list: this.$list
        }, params));
        return item;
    };

    Item.prototype.hasPrev = function() {
        return null !== this.data.prev || 0 < this.$prev.length || 'undefined' !== typeof this.prevItem;
    };

    Item.prototype.hasNext = function() {
        return null !== this.data.next || 0 < this.$next.length || 'undefined' !== typeof this.nextItem;
    };

    Item.prototype.getPrevId = function() {
        return null !== this.data.prev ? this.data.prev.id : null;
    };

    Item.prototype.getPrevData = function() {
        if (this.data.prev === null) {
            return null;
        }
        var params = {
            id: this.data.prev.id
        };
        if ('undefined' !== typeof this.data.prev.post) {
            params.post = this.data.prev.post;
        }
        if ('undefined' !== typeof this.data.prev.num) {
            params.num = this.data.prev.num;
        }
        return params;
    };

    Item.prototype.getNextId = function() {
        return null !== this.data.next ? this.data.next.id : null;
    };

    Item.prototype.getNextData = function() {
        if (this.data.next === null) {
            return null;
        }
        var params = {
            id: this.data.next.id
        };
        if ('undefined' !== typeof this.data.next.post) {
            params.post = this.data.next.post;
        }
        if ('undefined' !== typeof this.data.next.num) {
            params.num = this.data.next.num;
        }
        return params;
    };

    Item.prototype.setData = function (data) {
        $.extend(this.data, data);
    };

    Item.prototype.getCacheKey = function() {
        return this.data.type +':'+this.data.list+':'+this.data.id;
    };

    Item.prototype.clearCache = function() {
        Cache.remove(this.getCacheKey());
    };

    Item.prototype.loadData = function (additionalData) {
        var cacheItem = Cache.get(this.getCacheKey()),
            jqXHR;

        if ('undefined' === typeof cacheItem.value) {
            var dfd = $.Deferred();
            var keysToSend = ['id', 'type', 'increaseShows', 'version', 'list', 'params', 'tags', 'post', 'num', 'tpl', 'prev', 'next'];
            var dataForSend = {};
            var key = '';

            for (var i in keysToSend) {
                key = keysToSend[i];
                if (typeof this.data[key] !== 'undefined') {
                    dataForSend[key] = this.data[key];
                }
            }

            var data = $.extend({version: params.version}, dataForSend, additionalData);
            if (this.$list.data('params')) {
                data.params = this.$list.data('params');
            }
            var ajaxOptions = {
                url:      params.loadDataUrl,
                data:     data,
                dataType: 'json'
            };
            events.ajax.fire(ajaxOptions, dfd.promise());
            debug.time('load');
            jqXHR = $.ajax(ajaxOptions);
            jqXHR
                .always($.proxy(debug.timeEnd, debug, 'load'))
                .done($.proxy(events.loadData.fire, events.loadData))
                .done(dfd.resolve)
                .error(dfd.reject);
            cacheItem.value = jqXHR.promise();
        }
        cacheItem.value.done($.proxy(this.setData, this));

        return cacheItem.value;
    };

    // increaseShows
    (function() {
        var increaseShowsItem = null;
        events.loadPhoto.add(function() {
            increaseShowsItem = overlayMedia.item;
            debug.log('lazy increaseShows ' + increaseShowsItem.data.id);
        });

        events.ajax.add(function(ajaxOptions, dfd) {
            if (null !== increaseShowsItem) {
                ajaxOptions.data.increaseShows = {
                    type: increaseShowsItem.data.type,
                    id:   increaseShowsItem.data.id
                };
                debug.log('send increaseShows ', ajaxOptions.data);
                dfd.done(function(data) {
                    if (data.increaseShows) {
                        debug.log('increaseShows ok ' + increaseShowsItem ? ajaxOptions.data.increaseShows.id : '');
                        increaseShowsItem = null;
                    }
                    delete data.increaseShows;
                });
            }
        });
    })();

    // Google Analytics Events
    (function() {

        function pushEvent(category, action, trackingParams) {

            if ('undefined' !== typeof window.Tracker) {
                category = category || '';
                action = action || '';
                var label;
                var value;
                if (typeof trackingParams == 'object') {
                    if (!category && trackingParams['category']) {
                        category = trackingParams['category'];
                    }
                    if (!action && trackingParams['action']) {
                        action = trackingParams['action'];
                    }
                    if (trackingParams['label']) {
                        label = trackingParams['label'];
                    }
                    if (trackingParams['value']) {
                        value = trackingParams['value'];
                    }
                }

                var params = {
                    "category": category,
                    "action": action
                };
                if (typeof label != 'undefined') {
                    params['label'] = label;
                }
                if (typeof value != 'undefined') {
                    params['value'] = value;
                }
                window.Tracker.pushEvent(params);
            }
        }

        events.closeWindow.add($.proxy(pushEvent, null, 'Photo overlay', 'Click on close'));
        events.openWindow.add($.proxy(pushEvent, null, 'Photo overlay', 'Open'));
        events.previous.add($.proxy(pushEvent, null, 'Photo overlay', 'Click on previous'));
        events.next.add($.proxy(pushEvent, null, 'Photo overlay', 'Click on next'));
        events.postComment.add($.proxy(pushEvent, null, 'Photo overlay', 'Click on leave comment'));
    })();

    // li.ru, yandex, _trackPageview
    (function() {
        var lastPhotoUrl;
        var __ = window.__;

        function hit(title, referer) {
            if ('undefined' !== typeof window.Tracker) {
                window.Tracker.pushPageView(location.toString(), title, referer);
            }
        }

        events.loadPhoto.add(function() {
            var title;

            if (Boolean(_(overlayMedia.item).isUndefined()) === false) {

                if (/\S/.test(overlayMedia.item.data.name)) {
                    title = __('Фото «%photo%» в коллекции «%ideabook%»')
                        .replace('%photo%', overlayMedia.item.data.name || '');

                    if (typeof overlayMedia.item.data.ideabook !== 'undefined') {
                        title.replace('%ideabook%', overlayMedia.item.data.ideabook.name || '');
                    }
                }
                else {
                    if (typeof overlayMedia.item.data.ideabook !== 'undefined') {
                        title = __('Фото в коллекции «%ideabook%»')
                            .replace('%ideabook%', overlayMedia.item.data.ideabook.name || '');
                    }
                }

            } else {
                title = '';
            }

            lastPhotoUrl = location.href;

            hit(title, location.href.replace(location.hash || /$/, overlayMedia.closeUrlHash));
        });

        events.closeWindow.add(function() {
            hit(document.title, lastPhotoUrl);
        });
    })();

    function getItem($node, $list, options) {
        // наибыстрым образом определяем следующую и предыдущую фотку в списке
        debug.time('find prev & next');
        var $prev = $(), $next = $();

        debug.timeEnd('list prev & next');

        return new Item({
            type: $node.data('type'),
            id:   $node.data('id'),
            post: $node.data('post'),
            num:  $node.data('num'),
            prev: $prev,
            next: $next,
            list: $list
        });
    }

    $(document).on('ready PhotoOverlay::bind', function() {
        // bind
        $(params.delegateTo).off('click.PhotoOverlay');
        $(params.delegateTo).on('click.PhotoOverlay', params.selector, function (e) {
            var isNotPrimaryMouseButton = 'undefined' !== typeof e.which && 1 !== e.which;
            if (isNotPrimaryMouseButton) {
                return;
            }

            e.preventDefault();

            var $this = $(this);
            var $list = $(e.delegateTarget);
            var item = getItem($this, $list);
            var action = $this.data('photooverlayAction');
            var trackingParams = {};
            if ($list.data('tracking-event-mediaoverlay-category')) {
                trackingParams['category'] = $list.data('tracking-event-mediaoverlay-category');
            }
            if ($list.data('tracking-event-mediaoverlay-action')) {
                trackingParams['action'] = $list.data('tracking-event-mediaoverlay-action');
            }
            if ($list.data('tracking-event-mediaoverlay-label')) {
                trackingParams['label'] = $list.data('tracking-event-mediaoverlay-label');
            }
            if ($list.data('tracking-event-mediaoverlay-value')) {
                trackingParams['value'] = $list.data('tracking-event-mediaoverlay-value');
            }

            overlayMedia.init();
            overlayMedia.open(item, action, trackingParams);
        });

        $(window).on('hashchange', overlayMedia.hashChange);
    });

    $(document).on('ready', function () {
        if ((Boolean(window.location.hash))) {
            overlayMedia.hashChange();
        }
    });


    // export to global scope
    window.overlayMedia = {
        events: {
            cleanItemHtml:   events.cleanItemHtml,
            afterRenderItem: events.afterRenderItem,
            loadData:        events.loadData
        }
    };
})();
